import { render } from "./CoachwiseTrip.vue?vue&type=template&id=3d32791c&scoped=true"
import script from "./CoachwiseTrip.vue?vue&type=script&lang=js"
export * from "./CoachwiseTrip.vue?vue&type=script&lang=js"

import "./CoachwiseTrip.vue?vue&type=style&index=0&id=3d32791c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d32791c"]])

export default __exports__